import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

/**
 * Hook personalizado para manejar todas las operaciones API relacionadas con leads/contactos
 */
const useContactosAPI = () => {
    const { token, setToken, idUsuario, nombreCompleto } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    /**
     * Obtiene el cat�logo de leads con filtros aplicados
     */
    const obtenerCatalogoLeads = async (filtros) => {
        try {
            const response = await fetch("/api/leads/ObtenerCatalogoLeads/", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(filtros)
            });

            if (!response.ok) {
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                    return null;
                }
                throw new Error(`${response.status} ${response.statusText}`);
            }

            const data = await response.json();

            if (data.iResponseType === 1) {
                const detalles = JSON.parse(data.detalles);
                return {
                   // vendedores: detalles['table2'] || [],
                    //catEtapas: detalles['table3'] || [],
                    contactos: detalles['table2'] || [],
                    tags: detalles['table3'] || [],
                    proximoEvento: detalles['table4'] || [],
                    listaEventos: detalles['table5'] || [],
                    lista3LeadsLiberados: detalles['table6'] || [],
                    totalRegistros: detalles['table7']?.[0]?.iTotalRegistros ?? 0
                };
            } else {
                showErrorToast(data.vMessage);
                return null;
            }
        } catch (error) {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            return null;
        }
    };

    /**
     * Guarda un nuevo lead
     */
    const guardarLead = async (vTelefonoLead) => {
        try {
            const response = await fetch(`/api/leads/GuardarLead?vTelefonoLead=${encodeURIComponent(vTelefonoLead)}`, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                    return null;
                }
                throw new Error(`${response.status} ${response.statusText}`);
            }

            const data = await response.json();

            if (data.iResponseType === 1) {
                const objLead = JSON.parse(data.detalles);
                showSuccessToast(data.vMessage);
                return objLead[0];
            } else {
                showErrorToast(data.vMessage);
                return null;
            }
        } catch (error) {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            return null;
        }
    };

    /**
     * Verifica si un lead ya existe
     */
    const verificarLeadRepetido = async (vTelefonoLead) => {
        try {
            const response = await fetch(`/api/leads/VerificarLeadRepetido?vTelefonoLead=${encodeURIComponent(vTelefonoLead)}`, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                    return null;
                }
                throw new Error(`${response.status} ${response.statusText}`);
            }

            const data = await response.json();
            return data;
        } catch (error) {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            return null;
        }
    };

    /**
     * Cambia la etapa de un lead
     */
    const cambiarEtapaLead = async (idLead, idEtapa) => {
        try {
            const jDataSend = { idEtapa, idLead };

            const response = await fetch("/api/leads/changeEtapaLead/", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(jDataSend)
            });

            if (!response.ok) {
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                    return null;
                }
                throw new Error(`${response.status} ${response.statusText}`);
            }

            const data = await response.json();

            if (data.iResponseType === 1) {
                const detalles = JSON.parse(data.detalles);
                showSuccessToast("Cambio de etapa exitoso");
                return detalles[0];
            } else {
                showErrorToast(data.vMessage);
                return null;
            }
        } catch (error) {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            return null;
        }
    };

    /**
     * Obtiene eventos por vendedor
     */
    const obtenerEventosPorVendedor = async (idVendedor) => {
        try {
            const response = await fetch("/api/leads/eventosPorVendedor/", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ idVendedor })
            });

            if (!response.ok) {
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                    return null;
                }
                throw new Error(`${response.status} ${response.statusText}`);
            }

            const data = await response.json();
            
            if (data.iResponseType === 1) {
                const detalles = JSON.parse(data.detalles);
                return {
                    listaEventosPasados: detalles['table2'] ,
                    listaEventosHoy: detalles['table3'] ,
                    listaEventosFuturos: detalles['table4']
                };
            } else {
                showErrorToast(data.vMessage);
                return null;
            }
        } catch (error) {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            return null;
        }
    };

    /**
     * Obtiene leads liberados
     */
    const obtenerLeadsLiberados = async () => {
        try {
            const response = await fetch("/api/leads/obtenerLeadsLiberados/", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                    return null;
                }
                throw new Error(`${response.status} ${response.statusText}`);
            }

            const data = await response.json();

            if (data.iResponseType === 1) {
                const detalles = JSON.parse(data.detalles);
                return detalles['table2'] || [];
            } else {
                showErrorToast(data.vMessage);
                return [];
            }
        } catch (error) {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            return [];
        }
    };

    /**
     * Registra un comentario
     */
    const registrarComentario = async (idLead, vComentario, idTipoComentario) => {
        try {
            const response = await fetch(
                `/api/leads/RegistrarComentario?idLead=${idLead}&vComentario=${encodeURIComponent(vComentario)}&idTipoComentario=${encodeURIComponent(idTipoComentario)}`,
                {
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + token,
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (!response.ok) {
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                    return null;
                }
                throw new Error(`${response.status} ${response.statusText}`);
            }

            const data = await response.json();

            if (data.iResponseType === 1) {
                return JSON.parse(data.detalles);
            } else {
                showErrorToast(data.vMessage);
                return null;
            }
        } catch (error) {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            return null;
        }
    };

    /**
     * Guarda una notificaci�n
     */
    const guardarNotificacion = async (vTitulo, vCuerpo, idUsuarioTarget, objToAction) => {
        try {
            const jDataSend = {
                vTitulo,
                vCuerpo,
                idUsuarioTarget,
                objToAction
            };

            const response = await fetch("/api/leads/guardarNotificacion/", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(jDataSend)
            });

            if (!response.ok) {
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                    return null;
                }
                throw new Error(`${response.status} ${response.statusText}`);
            }

            const data = await response.json();

            if (data.iResponseType === 1) {
                const detalles = JSON.parse(data.detalles);
                return detalles.table2 || [];
            } else {
                showErrorToast(data.vMessage);
                return [];
            }
        } catch (error) {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            return [];
        }
    };

    return {
        obtenerCatalogoLeads,
        guardarLead,
        verificarLeadRepetido,
        cambiarEtapaLead,
        obtenerEventosPorVendedor,
        obtenerLeadsLiberados,
        registrarComentario,
        guardarNotificacion,
        idUsuario,
        nombreCompleto
    };
};

export default useContactosAPI;
